// src/pages/CapturedLeads.jsx
import React, { useEffect, useState } from 'react';
import AppShell from '../../components/AppShell';

const API = process.env.REACT_APP_API_BASE;

export default function CapturedLeads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/leads`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(res => res.json())
      .then(data => {
        setLeads(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <p>Loading leads...</p>;

  return (
    <AppShell>
      <div className="col-span-12">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {leads.map(lead => (
        <div key={lead._id} className="border p-4 rounded shadow-sm bg-white">
          <h2 className="text-lg font-semibold mb-1">{lead.name}</h2>
          <p className="text-sm text-gray-700 mb-1">📧 {lead.email}</p>
          <p className="text-sm text-gray-700 mb-1">📞 {lead.isd} {lead.phone}</p>
          <p className="text-sm text-gray-700 mb-1">🌍 {lead.country}</p>
          <p className="text-sm text-gray-700 mb-1">💼 {lead.company || 'N/A'}</p>
          <p className="text-sm text-gray-600 italic mb-2">{lead.notes}</p>
          <p className="text-xs text-gray-500">Interested as: <strong>{lead.interest}</strong></p>
          {lead.businessCardUrl && (
            <img
              src={API + lead.businessCardUrl}
              alt="Business Card"
              className="mt-2 max-h-40 object-contain border"
            />
          )}
        </div>
      ))}
    </div>
    </div>
    </AppShell>
  );
}
